var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPen = function SvgPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.278 6.46 9.541 3.72l1.34-1.313 2.711 2.71-1.314 1.341ZM4.888 14H2v-2.888l6.112-5.99 2.767 2.765L4.888 14ZM11.595.293a1 1 0 0 0-1.407-.007L.3 9.978a.998.998 0 0 0-.3.714V15a1 1 0 0 0 1 1h4.308a1 1 0 0 0 .714-.3l9.692-9.888c.383-.392.38-1.02-.008-1.408L11.595.293Z"
  })));
};
export default SvgPen;